import * as z from "zod/v4";

const returnScopedInput = z.object({
  scope: z.literal("return"),
  returnId: z.string().min(1),
});

const returnItemScopedInput = z.object({
  scope: z.literal("return_item"),
  returnId: z.string().min(1),
  returnItemId: z.string().min(1),
});

export const findOrCreateInventoryItemForLicensePlating = {
  name: "findOrCreateInventoryItemForLicensePlating" as const,
  input: z.discriminatedUnion("scope", [
    returnScopedInput,
    returnItemScopedInput,
  ]),
  output: z.object({ inventoryItemId: z.string() }),
};
